import email from './email';
import emailAdmin from './emailAdmin';

const app = {
  email,
  emailAdmin,
};

export default app;
